"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  system: {
    user: {
      bView: '观看',
      bEdit: '修改',
      bDelete: '删除',
      bBind: '绑定谷歌码',
      userManagement: "用户管理",
      username: "用户名",
      status: "状态",
      query: "查询",
      add: "新增",
      delete: "删除",
      resetPassword: "密码重置",
      unauthorized: "无权限",
      optionTip: "请选择",
      optionDisable: "禁用",
      optionValid: "有效",
      inputPlaceholder: "请选择",
      placeholder: "查询用户名",
      statusPlaceholder: "查询状态",
      table: {
        username: "用户名",
        sex: "性别",
        department: "部门",
        mobile: "手机",
        email: "邮箱",
        userStatus: "状态",
        loginFaildCount: "登录失败次数",
        createTime: "创建时间",
        operation: "操作",
        detail: {
          userInfo: "用户信息"
        },
        del: {
          deletedUser: "删除用户",
          confirmDelete: "确定删除该用户?"
        },
        edit: {
          updateUser: "修改用户",
          submit: "提交",
          cancel: "取消"
        },
        google: {
          bindCode: "绑定谷歌码",
          confirm: "确定",
          cancel: "取消"
        }
      },
      userTable: {
        newUsers: "新增用户",
        submit: "提交",
        reset: "重置",
        deleteWarn: "请选择需要删除的用户",
        deletedUser: "删除用户",
        confirmDelete: "确定删除该用户?",
        resetWarn: "请选择需要重置密码的用户",
        resetSuccess: "所选用户密码已重置为",
        resetSuccessInfo: '，请在第一次登入后修改！'
      },
      treeSelect: {
        placeholder: "请选择"
      },
      deleteUsers: {
        warn: "所选用户包含当前登录用户，无法删除",
        success: "删除用户成功"
      }
    },
    userAdd: {
      username: "用户名",
      mobile: "手机",
      email: "邮箱",
      role: "角色",
      department: "部门",
      status: "状态",
      statusInput: {
        valid: "有效",
        disable: "禁用"
      },
      gender: "性别",
      sexInput: {
        male: "男性",
        female: "女性",
        secret: "保密"
      },
      remark: "备注",
      treeSelect: {
        placeholder: "请选择"
      },
      formSelects: {
        error: "获取角色列表失败"
      },
      userAddFormSubmit: {
        success: "新增用户成功，初始密码为 1234Qwer"
      }
    },
    role: {
      viewRole: "角色信息",
      layTitle: "角色管理",
      roleName: "角色名称",
      query: "查询",
      createRole: "新增角色",
      roleID: "角色ID",
      roleNameHeader: "角色名称",
      roleDescription: "角色描述",
      rolePermission: "角色权限",
      submitButton: "保存",
      noPermission: "无权限",
      addRoleButton: "新增",
      deleteRoleButton: "删除",
      deleteRoleText1: "请选择需要删除的角色",
      deleteRoleText2: "删除角色",
      deleteRoleText3: "确定删除所选角色？",
      deleteRoleText4: "删除角色成功",
      editRoleText1: "修改角色",
      editRoleText2: "修改角色成功",
      createRoleText1: "新增角色成功",
      hintsText: "提示",
      noPermissionConfirmText: "当前角色未授予任何权限，是否继续？",
      createTimeText: "创建时间",
      operationText: "操作",
      placeholder: "查询角色名称"
    },
    menu: {
      menuManagement: "菜单管理",
      nameHeader: "名称",
      queryText: "查询",
      addMenu: "新增菜单",
      parentMenuID: "上级ID",
      menuName: "名称",
      menuType: "类型",
      menuType1: "菜单",
      menuType2: "按钮",
      menuIcon: "图标",
      menuPermission: "权限",
      menuListOrder: "排序",
      submitButton: "保存",
      warningText1: "只能选择一个节点作为父级！",
      warningText2: "不能选择按钮作为父级！",
      warningText3: "请勾选需要删除的菜单或按钮",
      warningText4: "数据未作任何修改！",
      hintsText: "提示",
      deleteConfirmText: "当您点击确定按钮后，这些记录将会被彻底删除，如果其包含子记录，也将一并删除！",
      deleteSuccessText: "删除成功！",
      menuInformationExcel: "菜单信息表.xlsx",
      addText: "新增",
      deleteText: "删除",
      exportExcelText: "导出Excel",
      editMenuText: "修改菜单",
      editButtonText: "修改按钮",
      selectIconText: "图标选择",
      confirmText: "确定",
      addButtonText: "新增按钮",
      editText: "修改",
      editSuccessText: "修改成功",
      addSuccessText: "新增成功",
      placeholder: "查询菜单"
    },
    dept: {
      department: "部门",
      layTitle: "部门管理",
      name: "名称",
      query: "查询",
      formHeader: "新增部门",
      parentDepartmentID: "上级ID:",
      departmentName: "部门名称：",
      departmentSort: "部门排序：",
      submit: "保存",
      eleTreeHeaderText: "修改部门",
      dropdownAddWarnText: "只能选择一个节点作为父级！",
      dropdownDeleteWarnText: "请勾选需要删除的部门",
      dropdownDeletePromptText: "提示",
      dropdownDeleteInfoText: "当您点击确定按钮后，这些记录将会被彻底删除，如果其包含子记录，也将一并删除！",
      dropdownDeleteSuccessText: "删除成功！",
      dropdownExportText: "部门信息表.xlsx",
      optionAdd: "新增部门",
      optionDelete: "删除部门",
      optionExport: "导出Excel",
      resetText: "新增部门",
      formSubmitEditText: "修改",
      formSubmitWarnText: "数据未作任何修改!",
      formSubmitEditSuccessText: "修改成功",
      formSubmitAddSuccessText: "新增成功",
      placeholder: "查询部门",
      deptName: "部门名称"
    },
    codeSortUpdate: {
      dictionaryCategoryId: "字典分类id",
      categoryName: "分类名称",
      categoryCode: "分类代码",
      parentCode: "上级代码",
      description: "描述",
      remark: "备注",
      dateCreated: "创建时间",
      operationText: "操作",
      updateFormWarnText: "数据未作任何修改！",
      updateFormSuccessText: "数据修改成功"
    },
    codeSortAdd: {
      categoryName: "分类名称",
      categoryCode: "分类代码",
      parentCode: "上级代码",
      description: "描述",
      remark: "备注",
      addFormSuccessText: "新增字典分类成功"
    },
    codeSort: {
      layTitle: "字典分类",
      categoryName: "分类名称",
      query: "查询",
      tableAddOpenText: "新增字典分类",
      tableAddBtnConfirmText: "提交",
      tableAddBtnResetText: "重置",
      toolBarDeleteWarnText: "请选择需要删除的字典分类",
      toolBarDeleteConfirmTex: "删除字典分类",
      toolBarDeleteConfirmInformation: "确定删除该字典分类?",
      toolDelConfirmText: "删除字典分类",
      toolDelConfirmInformation: "确定删除该字典分类?",
      toolEditOpenText: "修改字典分类",
      toolEditBtnConfirmText: "提交",
      toolEditBtnResetText: "取消",
      iniTableCodeTitle: "代码",
      iniTableNameTitle: "名称",
      iniTableRemarkTitle: "备注",
      iniTableCreateTimeTitle: "创建时间",
      iniTableOperationTitle: "操作",
      deleteCodeSortsSuccessText: "删除字典分类成功",
      placeholder: "查询字典分类名称",
      categoryCode: "分类代码"
    },
    code: {
      layTitle: "字典管理",
      parentCode: "上级代码",
      code: "代码",
      codeName: "代码名称",
      query: "查询",
      toolBarAddOpenText: "新增字典",
      toolBarAddBtnSubmitText: " 提交",
      toolBarAddBtnResetText: "重置",
      toolBarDeleteWarnText: "请选择需要删除的字典",
      toolBarDeleteConfirmText: "删除字典",
      toolBarDeleteConfirmInformation: "确定删除该字典?",
      toolBarLoadReapplicationConfirmText: "确定刷新缓存",
      toolBarLoadReapplicationConfirmInformation: "确定刷新缓存?",
      toolBarLoadReapplicationSuccessText: "刷新缓存成功",
      toolBarGatewayLoadConfigCacheConfirmText: "确定刷新缓存",
      toolBarGatewayLoadConfigCacheConfirmInformation: "确定刷新所有网关服务器的缓存?",
      toolBarGatewayLoadConfigCacheSuccessText: "刷新网关服务器缓存成功",
      toolBarMerchLoadConfigCacheConfirmText: "确定刷新缓存",
      toolBarMerchLoadConfigCacheConfirmInformation: "确定刷新所有企业端服务器的缓存?",
      toolBarMerchLoadConfigCacheSuccessText: "刷新企业服务器缓存成功",
      toolBarAgentLoadConfigCacheConfirmText: "确定刷新缓存",
      toolBarAgentLoadConfigCacheConfirmInformation: "确定刷新所有代理端服务器的缓存?",
      toolBarAgentLoadConfigCacheSuccessText: "刷新代理服务器缓存成功",
      codeTableDelConfirmText: "删除字典",
      codeTableDelConfirmInformation: "确定删除该字典?",
      codeTableEditOpenText: "修改字典",
      codeTableEditBtnSubmitText: "提交",
      codeTableEditBtnCancelText: "取消",
      initTableSortCodeTitle: "字典分类",
      initTableCodeTitle: "代码",
      initTableNameTitle: "字典名称",
      initTableParentCodeTitle: "上级代码",
      initTableDescriptionTitle: "描述",
      initTableRemarkTitle: "备注",
      initTableCreateTimeTitle: "创建时间",
      initTableOperationTitle: "操作",
      deleteCodeSuccess: "删除字典成功",
      placeholder: "查询关键词",
      cache: "刷新缓存",
      gatewayCache: "刷新网关缓存",
      organizationCache: "刷新企业端缓存",
      organizationSendCache: "刷新企业发送端缓存",
      proxyCache: "刷新代理端缓存",
      cacheRefreshed: '缓存已刷新',
      agentCacheRefreshed: '代理缓存指令已发送',
      merchantCacheRefreshed: '企业缓存指令已发送',
      gatewayCacheRefreshed: '网关缓存指令已发送',
      dictionaryName: "字典名称",
      dictionaryCategory: "字典分类"
    },
    codeAdd: {
      dictionaryName: "字典名称:",
      code: "代码: ",
      parentCode: "上级代码:",
      dictionaryCategory: "字典分类:",
      description: "描述:",
      remark: "备注:",
      formSelectsErrorText: "获取字典分类列表失败",
      codeAddFormSuccessText: "新增字典成功"
    },
    codeUpdate: {
      dictionaryI: "字典id:",
      dictionaryName: "字典名称:",
      code: "代码: ",
      parentCode: "上级代码:",
      dictionaryCategory: "字典分类:",
      description: "描述:",
      remark: "备注:",
      formSelectsErrorText: "获取字典分类列表失败",
      codeUpdateFormWarnText: "数据未作任何修改",
      codeUpdateFormSuccessText: "数据修改成功"
    },
    areaNumber: {
      layTitle: "地区号码",
      areaName: "地区名称",
      query: "查询",
      toolbarAreaNumberTableAddOpenText: "新增地区号码",
      toolbarAreaNumberTableAddBtnSubmitText: "提交",
      toolbarAreaNumberTableAddBtnResetText: "重置",
      toolbarAreaNumberTableDeleteWarnText: "请选择需要删除的地区号码",
      toolbarAreaNumberTableDeleteConfirmText: "删除地区号码",
      toolbarAreaNumberTableDeleteConfirmInformation: "确定删除该地区号码?",
      toolbarAreaNumberTableDelConfirmText: "删除地区号码",
      toolbarAreaNumberTableDelConfirmInformation: "确定删除改地区号码",
      toolAreaNumberTableEditOpenText: "修改地区号码",
      toolAreaNumberTableEditBtnSubmitText: "提交",
      toolAreaNumberTableEditBtnCancelText: "取消",
      initTableAreaTitle: "地区名称",
      initTableAreaNoTitle: "区号",
      initTableCreateTime: "创建时间",
      initTableOperation: "操作",
      deleteCodeSortsSuccessText: "删除字典分类成功",
      placeholder: "查询地区名称"
    },
    areaNumberAdd: {
      areaName: "地区名称:",
      areaCode: "地区区号:",
      userAddFormSuccessText: "新增地区号码成功"
    },
    areaNumberUpdate: {
      areaCodeId: "地区号码id:",
      areaName: "地区名称:",
      areaCode: "地区区号:",
      FormSubmitWarnText: "数据未作任何修改！",
      FormSubmitSuccessText: "数据修改成功"
    }
  },
  dashboard: {
    lineChartTitle: '最近七天企业支付总金额（USD）',
    receiveSuccess: " 今日SMS: 接收成功",
    rechargeAmount: "今日企业充值额",
    waitForSubmitting: "今日SMS: 等待提交",
    // submitSuccess: " 今日SMS: 提交成功",
    queryApiTimes: "今日访问接口次数",
    totalPayAmount: "今日支付总额",
    rechargeSuccess: "今日充值成功次数",
    submitSuccess: "今日提交上游成功次数",
    rateSuccessForSevenDays: "最近七天成功成功率",
    rateSuccess: "提交成功率",
    receiptSuccessForSevenDays: "最近七天回执成功率",
    receiptSuccess: "回执成功率",
    payAmount: "支付总金额",
    mon: "星期一",
    tue: "星期二",
    wed: "星期三",
    thu: "星期四",
    fri: "星期五",
    sat: "星期六",
    sun: "星期日",
    top5SuccessRate: "昨天成功率最高的企业",
    top6Channels: "昨天成功率最高的通道商",
    top5PayCurrency: "今日当前各货币支付金额",
    top5FailureRate: "昨天失败率最高的企业",
    successRate: "成功率",
    failureRate: "失败率",
    top10SmsCount: "昨天支付总额最高的前十企业",
    top10SmsCountTotal: "支付总额",
    top10Agent: "昨天名下企业充值总额最高的前十代理",
    top10PaymentYesterday: '昨天充值前十的通道',
    goodAfternoon: '下午好',
    lastLoginTime: '上次登录时间',
    lastLoginIp: '上次登录地址',
    welcome: '欢迎登录',
    moneyUnit: '元',
    agent: {
      agentLabel: '代理名称',
      sendSMSTotal: '发送总数',
      numOfOrgs: '10日内活跃企业数量',
      smsUnit: '条',
      orgUnit: '间',
      availableQuota: '可用额度',
      rechargeTotal: '充值总额',
      overall: '合计',
      availableProfit: '可用利润',
      totalConsumption: '消费总额',
      enterpriseRechargeTotal: '企业充值总额',
      queryAPIToday: '今日访问API',
      paySuccessToday: '今日充值成功',
      frozenAmount: '冻结金额',
      uncreditedAmount: '未入账金额',
      SmsSent: '短信数量',
      successTotal: '成功数',
      today: '当天',
      profit: '利润',
      cost: '成本',
      top5Orgs: '信息发送量最高的企业',
      top10Orgs: '支付总额前十的企业'
    },
    merchant: {
      normal: "正常",
      blocked: "锁定",
      unsuccessful: "未成功",
      approved: "认证通过",
      notApproved: "认证失败",
      redirectToDocs: '接口文档',
      availableBalance: '可用金额',
      moneyUnit: '元',
      consumptionAmount: '消费金额',
      frozenAmount: '冻结金额',
      uncreditedAmount: '未入账金额',
      totalSMSSent: '发送总数',
      totalRecharge: '充值总额',
      smsUnit: '条',
      companyInformation: '企业信息',
      organizationName: '企业名称',
      organizationStatus: '企业状态',
      approvalStatus: '认证状态',
      organizationCode: '企业编号',
      md5Key: 'MD5秘钥',
      accessNumber: '接入号码',
      accessCode: '接入密码',
      numberOfConnections: '连接数',
      channelRate: '速率',
      goToDocs: '接口文档',
      HTTPAPIText: 'HTTP对接',
      SMPPAPIText: 'SMPP对接',
      top5SmsSent: '前五天提交成功的信息量',
      top5Pay: '前五天支付成功金额',
      numSuccesses: '成功数量'
    }
  },
  common: {
    admin: "管理用戶",
    agent: "代理用戶",
    merchant: "企业用户",
    currencyType: '货币类型',
    HKD: '港币',
    USD: '美元',
    CNY: '人民币',
    noData: '没有数据',
    emailFormat: '电子邮件格式不正确',
    withdraw: "提现",
    networkError: "网络错误",
    warning: "警告",
    required: "必要",
    success: "成功",
    error: "错误",
    fetchError: "提取错误",
    examinationPassed: "审核通过",
    auditNotPassed: "审核不通过",
    QRCode: "验证码",
    permission: "权限",
    userAuthorityManagement: "权限管理",
    newTariff: "新增资费",
    cost: "网关配置",
    addNew: "添新",
    update: "更改",
    resetPassword: "密码重置",
    batchLock: "批量锁定",
    batchUnlock: "批量解锁",
    invalid: "作废",
    reject: "认证失败",
    approve: "认证通过",
    recharge: "充值",
    return: "返回",
    add: "新增",
    edit: "修改",
    delete: "删除",
    search: "查询",
    stop: "停顿",
    buildAndStart: "创建和起动",
    import: "导入",
    export: "导出",
    exportNumber: "导出号码",
    exportAreaReport: "导出地区号码",
    exportBrokenNumber: "导出破叫号码",
    checkNumberList: "查看号码列表",
    exportDailyReport: "导出每日报告",
    exportMonthlyReport: "导出每月报告",
    addPreviousDailyReport: "添加前一天报告",
    addPreviousMonthlyReport: "添加前一月报告",
    uploadNumberPool: "号码池功能",
    deleteNumberPool: "号码池删除",
    createTime: "创建时间",
    creator: "创建者",
    updateTime: "修改时间",
    editor: "修改者",
    remark: "备注",
    oldPassword: "旧密码",
    password: "密码",
    confirmPassword: "确认密码",
    submit: "提交",
    reset: "重置",
    cancel: "取消",
    confirm: "确定",
    updateMerchant: "抢单",
    uploadedMerchant: "更新凭证",
    uploadMerchant: "上传凭证",
    showImage: "显示凭证",
    queryKid: "查询Id",
    queryAgent: "查询代理",
    queryMerchant: "查询码商",
    queryReviewAccount: "查询审核账号",
    updateAdmin: "审核",
    refuse: "拒绝审核",
    changePwd: "修改密码",
    updateStatus: "状态更新",
    forceChangePwd: "修改密码",
    resetMFASecret: "重置Google验证",
    resetPwd: "重置密码",
    frozen: "冻结",
    restore: "恢复",
    fromTime: "开始时间",
    toTime: "结束时间",
    fromData: "开始日期",
    toDate: "结束日期",
    checkDailyReportData: "查看当天的数据",
    reportExportText: "表格导出",
    viewStatisticText: "查看统计",
    date: "日期",
    time: "时间",
    uploadDocumentMessage: "选择档案",
    usernameText: "用户名",
    contentText: "内容",
    batchNumber: "批次号",
    operator: "平台",
    statusText: "状态",
    operationText: "操作",
    start: "启动",
    pause: "暂停",
    toText: "至",
    createTimeText: "创建时间",
    lockTimeText: "锁定时间",
    pleaseEnterText: "请输入",
    pleaseSelectText: "请选择",
    pleaseClickText: "请点击",
    batchDeleteText: "批量删除",
    batchUpdatePermissionText: "批量更新权限",
    systemWarning: '系统提示',
    noPermissionWarning: "您没有权限访问该资源，请联系管理员",
    goBack: '退回',
    invalidTokenWarning: "登录已超时或者账号在别处登录，请重新登录",
    login: '登入',
    cancelUser: "批量作废",
    clickToShowImage: "图片",
    notedText: "已读",
    closedText: "关闭",
    previewText: "预览",
    remarkText: "备注",
    forceText: "强制",
    notForceText: "非强制",
    callbackDown: "通知下游",
    regetNotify: "重新获取通知",
    notifyDetail: "回执详情",
    unknownText: "Unknown"
  },
  route: {
    organizationRechargeManagement: '充值管理',
    channelOperatorDailyReport: '通道运营商日报表',
    channelOperatorMonthlyReport: '通道运营商月报表',
    bindGoogleCode: '绑定谷歌码',
    payPasswordUpdate: '修改支付密码',
    personalAccountManagement: '账号管理',
    passwordUpdate: '密码修改',
    channelNumberPoolManagement: '号码池管理',
    batchSuccessRate: '批次成功率',
    exportedExcel: '导出报表',
    totalDailyReport: '总日报',
    generalDailyReport: '综合日报表',
    allConsumeAmountDailyReport: '全部资费日报表',
    allConsumeAmountMonthlyReport: '全部资费月报表',
    consumeAmountDailyReport: '资费详情日报表',
    consumeAmountMonthlyReport: '资费详情月报表',
    agentDailyReport: '代理日报表',
    organizationDailyReport: '企业日报表',
    systemManagement: '系统管理',
    userManagement: '用户管理',
    menuManagement: '菜单管理',
    departmentManagement: '部门管理',
    dictionaryCategory: '字典分类',
    dictionaryManagement: '字典管理',
    regionManagement: '地区管理',
    loginBlackList: "登入黑名单",
    agentManagement: '代理管理',
    agentCost: "代理网关",
    agentPermission: '代理权限',
    agentSettings: '代理配置',
    agentBlackList: "代理黑名单",
    organizationManagement: '企业管理',
    organizationCost: "企业网关",
    organizationUserPermission: '企业用户权限',
    organizationOperationLog: '企业操作日志',
    organizationBlacklist: "企业黑名单",
    organizationUserSettings: '企业用户配置',
    financeManagement: '财务管理',
    agentConversionQuotaList: '代理转换额度列表',
    agentRechargeOrder: '代理充值订单',
    organizationRechargeOrder: '企业充值订单',
    organizationMonthlyReport: '企业月报表',
    reportManage: '报表管理',
    agentMonthlyReport: '代理月报表',
    channelDailyReport: '通道日报表',
    agentRemitOrder: '代理提现订单',
    agentRemitOrderReport: '代理提现订单报表',
    organizationRemitOrder: '企业提现订单',
    organizationRemitOrderReport: '企业提现订单报表',
    amountChangeRecord: '金额变动记录',
    organizationAmountChangeRecord: '企业金额变动记录',
    organizationAmountChangeRecordReport: '企业金额变动记录报表',
    agentAmountChangeRecord: '代理金额变动记录',
    agentAmountChangeRecordReport: '代理金额变动记录报表',
    organizationUserManagement: '企业用户管理',
    channelMonthlyReport: '通道月报表',
    orderManagement: "订单管理",
    orderRecords: "充值订单记录",
    orderRecordsReport: "充值订单记录报表",
    orderNotify: "充值订单回执",
    orderNotifyReport: "充值订单回执报表",
    refundOrder: "退款订单记录",
    refundOrderReport: "退款订单记录报表",
    orderHistoryManagement: "历史订单管理",
    orderRecordsHistory: "历史充值订单记录",
    orderNotifyHistory: "历史充值订单回执",
    refundOrderHistory: "历史退款订单记录",
    smsManagement: '短信管理',
    smsTemplateManagement: "短信模板",
    smsSendBox: "发件箱",
    smsSendRecord: "发送记录",
    smsReturnRecord: "发送回执",
    smsWaitingApproval: "等待审核",
    smsManualApproval: "人工发送审核",
    smsScheduledMsg: "定时短信",
    smsBlacklist: "手机黑名单",
    smsSensitiveWords: "敏感词",
    smsSendBoxSubmitByForm: "我要发送",
    smsSendBoxSubmitByTable: "表格提交",
    smsSendBoxBatchSubmitByForm: "我要发送(动态内容)",
    smsSendBoxSubmitByTemplate: "模板提交",
    sendCreateTimeList: "发送创建时间列表",
    smsChannelGroup: "通道分组管理",
    payChannelGroup: "通道分组管理",
    smsChannelGroupChannel: "通道分组通道明细",
    smsChannelGroupMember: "通道分组成员明细",
    smsChannelGroupCost: "通道分组资费組合明细",
    payChannelGroupCost: "通道分组资费組合明细",
    payChannelGroupCostMember: "通道分组资费組合成员明细",
    channelManagement: "通道管理",
    groupManagement: "分组管理",
    groupMember: "分组明细",
    channelNumberPoolLog: "号码池日志",
    smsChannel: "短信通道",
    smsChannelCost: "短信通道资费",
    payChannel: "支付通道",
    payChannelCost: "支付通道资费",
    currencyExchangeRate: "货币转换汇率",
    historyRecord: "历史记录",
    historySendBox: "历史发件箱",
    historySentRecord: "历史发送记录",
    historyReturnedRecord: "历史发送回执",
    historySendBoxSearch: "历史发件箱(查询)",
    historySentRecordSearch: "历史发送记录(查询)",
    historyReturnedRecordSearch: "历史发送回执(查询)",
    monitorSystem: "系统监控",
    monitorDaily: "系统日志",
    monitorLogin: "登录日志",
    scheduledTaskTitle: "任务调度",
    scheduledTask: "定时任务",
    scheduledTaskLog: "调度日志",
    scheduledSMS: "定时短信",
    scheduledSMSLog: "定时短信日志",
    agentSmsManagement: '短信管理(代理)',
    agentSmsSendBox: "发件箱(代理)",
    agentSmsSendRecord: "发送记录(代理)",
    agentHistorySendBox: "历史发件箱(代理)",
    agentHistorySendRecord: "历史发送记录(代理)",
    orderList: "订单列表",
    withdrawList: "提现列表",
    grabOrder: "抢单列表",
    dashboard: "首页",
    documentation: "文档",
    guide: "引导页",
    systemConfig: "系统配置表",
    config: "配置",
    checkData: "查看数据",
    dataQuery: "查询数据",
    smsQueryAnalysis: "查询短信分析",
    checkPhone: "查看手机号码",
    randomFailureNumber: "随机失败号码",
    pastComprehensiveAnalysis: "过往综合分析",
    comprehensiveDataAnalysis: "短信分析综合数据",
    companyReport: "公司报告",
    companyDailyReport: "公司每日报告",
    companyMonthlyReport: "公司每月报告",
    realTimeComprehensiveAnalysis: "即时综合分析",
    receiptNumberAnalysis: "回执号码分析",
    areaReportAnalysis: "地区号码分析",
    channelInformationList: "通道信息列表",
    quartzConfig: "定时器配置表",
    channelRateAnalysis: "通道比率分析",
    enterpriseRateAnalysis: "企业比率分析",
    hourlyDataReportAnalysis: "每小时成功率分析",
    accountManagement: "用户管理",
    accountView: "用户列表",
    roleManagement: "角色管理",
    permission: "权限测试页",
    rolePermission: "角色权限",
    pagePermission: "页面权限",
    directivePermission: "指令权限",
    icons: "图标",
    components: "组件",
    tinymce: "富文本编辑器",
    markdown: "Markdown",
    jsonEditor: "JSON 编辑器",
    dndList: "列表拖拽",
    splitPane: "Splitpane",
    avatarUpload: "头像上传",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "小组件",
    backToTop: "返回顶部",
    dragDialog: "拖拽 Dialog",
    dragSelect: "拖拽 Select",
    dragKanban: "可拖拽看板",
    charts: "图表",
    keyboardChart: "键盘图表",
    lineChart: "折线图",
    mixChart: "混合图表",
    example: "综合实例",
    nested: "路由嵌套",
    menu1: "菜单1",
    "menu1-1": "菜单 1-1",
    "menu1-2": "菜单 1-2",
    "menu1-2-1": "菜单 1-2-1",
    "menu1-2-2": "菜单 1-2-2",
    "menu1-3": "菜单 1-3",
    menu2: "菜单 2",
    Order: "订单",
    Table: "Table",
    dynamicTable: "动态 Table",
    dragTable: "拖拽 Table",
    inlineEditTable: "Table 内编辑",
    complexTable: "综合 Table",
    tab: "Tab",
    form: "表单",
    createArticle: "创建文章",
    editArticle: "编辑文章",
    articleList: "文章列表",
    errorPages: "错误页面",
    page401: "401",
    page404: "404",
    errorLog: "错误日志",
    excel: "Excel",
    exportExcel: "导出 Excel",
    selectExcel: "导出 已选择项",
    mergeHeader: "导出 多级表头",
    uploadExcel: "上传 Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "换肤",
    clipboardDemo: "Clipboard",
    i18n: "国际化",
    externalLink: "外链",
    profile: "个人中心"
  },
  navbar: {
    dashboard: "首页",
    github: "项目地址",
    logOut: "退出登录",
    profile: "个人中心",
    theme: "换肤",
    size: "布局大小",
    enterFullScreen: '进入全屏幕',
    exitFullScreen: '退出全屏幕',
    switchLanguage: '更换语言',
    refreshCache: '刷新缓存'
  },
  login: {
    capslockOn: '大写锁定已打开',
    emailError: "请输入正确的用户名",
    passwordError: "密码不能少于6位数字",
    title: "系统登录",
    titleAdmin: "管理系统登录",
    titleAgent: "代理系统登录",
    titleMerchant: "企业系统登录",
    logIn: "登录",
    username: "账号",
    password: "密码",
    any: "随便填",
    thirdparty: "第三方登录",
    thirdpartyTips: "本地不能模拟，请结合自己业务进行模拟！！！",
    authenticator: "Google验证码",
    rememberMe: "记住我"
  },
  documentation: {
    documentation: "文档",
    github: "Github 地址"
  },
  permission: {
    addRole: "新增角色",
    editPermission: "编辑权限",
    roles: "你的权限",
    switchRoles: "切换权限",
    tips: "在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。",
    delete: "删除",
    confirm: "确定",
    cancel: "取消"
  },
  guide: {
    description: "引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于",
    button: "打开引导"
  },
  components: {
    documentation: "文档",
    tinymceTips: "富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见",
    dropzoneTips: "由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone",
    stickyTips: "当页面滚动到预设的位置会吸附在顶部",
    backToTopTips1: "页面滚动到指定位置会在右下角出现返回顶部按钮",
    backToTopTips2: "可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素",
    imageUploadTips: "由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。"
  },
  partner: {
    dynamicTips1: "固定表头, 按照表头顺序排序",
    dynamicTips2: "不固定表头, 按照点击顺序排序",
    dragTips1: "默认顺序",
    dragTips2: "拖拽后顺序",
    name: "名称",
    rate: "费率",
    money: "金额",
    search: "搜索",
    add: "添加",
    amount: "余额",
    rechangeAmount: "总充值金额",
    customeAmount: "总消耗金额",
    freeze: "冻结金额",
    export: "导出",
    reviewer: "审核人",
    id: "序号",
    date: "更新时间",
    author: "作者",
    readings: "阅读数",
    status: "状态",
    actions: "操作",
    edit: "编辑",
    publish: "发布",
    draft: "草稿",
    delete: "删除",
    cancel: "取 消",
    confirm: "确 定",
    phone: "手机",
    email: "邮箱",
    account: "登录账户",
    pwd: "密码",
    againPwd: "再次输入",
    merchantName: "商户名称",
    merchantId: "商户ID",
    currentAmount: "当前金额",
    opAmount: "变动金额",
    odAmount: "已变动金额",
    actualAmount: "实际金额",
    type: "类型",
    partner: "接入ID",
    openApiAccountName: "接人名称",
    orderNo: "单号"
  },
  order: {
    dynamicTips1: "固定表头, 按照表头顺序排序",
    dynamicTips2: "不固定表头, 按照点击顺序排序",
    dragTips1: "默认顺序",
    dragTips2: "拖拽后顺序",
    name: "名称",
    rate: "费率",
    money: "金额",
    search: "搜索",
    add: "添加",
    amount: "余额",
    rechangeAmount: "总充值金额",
    customeAmount: "总消耗金额",
    freeze: "冻结金额",
    export: "导出",
    reviewer: "审核人",
    id: "序号",
    date: "更新时间",
    author: "作者",
    readings: "阅读数",
    status: "状态",
    actions: "操作",
    edit: "编辑",
    publish: "发布",
    draft: "草稿",
    delete: "删除",
    cancel: "取 消",
    confirm: "确 定",
    create_time: "创建时间",
    finish_time: "完成时间",
    update_time: "更新时间",
    pdd_confirm_time: "确认收货时间",
    pdd_send_time: "发货时间",
    open_api_account_kid: "合作商id",
    order_no: "订单号",
    user_order_no: "第三方订单号",
    order_mobile: "下单号码",
    pay_url: "支付地址",
    pdd_status: "收货状态",
    review_time: "审核时间",
    partner_info: "合作商户信息",
    partner_kid: "合作商户id",
    partner_name: "合作商户名称",
    review_user_info: "审核人信息",
    review_user_kid: "审核人Id",
    review_user_name: "审核人名称",
    bank_address: "银行信息",
    card: "银行卡号",
    withdraw_info: "提现人信息",
    agent_kid: "代理id",
    merchant_kid: "合作商id",
    review_account_kid: "审核人id",
    start_create_time: "创建开始时间",
    end_create_time: "结束开始时间",
    agent_info: "代理相关",
    certificate_url: "凭证照片",
    msgId: "回执ID",
    resMsg: "回执信息",
    notifyTime: "回执时间",
    notifyProperty: "回执参数"
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '备注',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '支付状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  example: {
    warning: "创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见"
  },
  errorLog: {
    tips: "请点击右上角bug小图标",
    description: "现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。",
    documentation: "文档介绍"
  },
  excel: {
    export: "导出",
    selectedExport: "导出已选择项",
    placeholder: "请输入文件名(默认excel-list)"
  },
  zip: {
    export: "导出",
    placeholder: "请输入文件名(默认file)"
  },
  pdf: {
    tips: "这里使用   window.print() 来实现下载pdf的功能"
  },
  theme: {
    change: "换肤",
    documentation: "换肤文档",
    tips: "Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。"
  },
  tagsView: {
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeAll: "关闭所有"
  },
  settings: {
    title: "系统布局配置",
    theme: "主题色",
    tagsView: "开启 Tags-View",
    fixedHeader: "固定 Header",
    sidebarLogo: "侧边栏 Logo"
  },
  SMS: {
    msgIdText: '商户订单号',
    superiorAgentIncome: '上級代理收益',
    AutomaticConfiguration: '自动配置',
    remark: '备注',
    verificationCode: '验证码',
    rechargeAmount: '充值金额',
    increaseAmount: '增加金额',
    convertAmount: '转换后金额',
    exchangeRate: '汇率',
    moneyTypeFrom: '原始币种',
    moneyTypeTo: '目标币种',
    moneyTypeToReport: '支付所用货币类型',
    rechargeMethod: '充值方式',
    agentId: '代理商',
    agentNameText: "代理商",
    organizationName: '企业名称',
    salesman: '销售人',
    status: '状态',
    approveState: '认证状态',
    checkNumberCountState: '号码条数审核状态',
    username: '用户名',
    organizationCode: '企业编号',
    loginAccount: '登录账号',
    fullName: '姓名',
    totalRechargeYuan: '充值总额',
    amountAvailableYuan: '可用金额',
    consumptionAmountYuan: '消费金额',
    frozenAmount: '冻结金额',
    uncreditedAmount: '待入帐金额',
    numberOfSent: '发送条数',
    smppConnectionStatus: 'smpp连接状态',
    smsApproveType: '短信审核',
    createTime: '创建时间',
    operating: '操作',
    interfaceType: '开通接口',
    delayedSettlement: '延时结算',
    bindIP: '绑定IP',
    smsSignature: '短信签名',
    corporateWebsite: '企业网站',
    companyAddress: '企业地址',
    enterpriseMailbox: '企业邮箱',
    contactNumber: '联系电话',
    contactPerson: '联系人',
    confirmPassword: '确认密码',
    password: '密码',
    alarm: '警报',
    success: '成功',
    accountType: '账号类型',
    lastLoginIPAddress: '上次登录IP地址',
    lastLoginTime: '上次登录时间',
    pleaseSelectUserType: '请选择用户类型',
    balanceProcessing: '余额处理',
    tariffName: '资费名称',
    tariff: '资费',
    smsType: '短信类型',
    areaCode: '地区区号',
    channel: '通道',
    operationUser: '操作用户',
    operationContent: '操作内容',
    operationMethod: '操作方法',
    timeConsuming: '耗时',
    methodParameters: '方法参数',
    methodResponse: '返回参数',
    ipAddress: 'IP地址',
    operatingLocation: '操作地点',
    canNotBeEmpty: '不能为空',
    contactMobile: '联系电话',
    workingFor: '正在为',
    description: '描述',
    name: '名称',
    accountCannotBeEmpty: '账号不能为空',
    rolePermissions: '角色权限',
    updateRolePermissions: '更新角色权限',
    parentId: '上级ID',
    type: '类型',
    icon: '图标',
    permission: '权限',
    sequence: '排序',
    createNewUser: '添加新用户',
    editUser: '修改用户',
    create: '添加',
    update: '更新',
    viewUser: '查看用户',
    levelCode: '级别',
    systemName: '平台名称',
    smsDomainAddress: '域名地址',
    platformLOGO: '平台LOGO',
    platformBackgroundImage: '平台背景图片',
    upAgentId: '上级代理商',
    amountOfProfit: '利润金额',
    userStatus: '用户状态',
    numberOfFailedLogins: '登录失败次数',
    agentName: '名称',
    agentAccount: '用户名',
    payPassword: '支付密码',
    phoneNumber: '手机号',
    email: '邮箱',
    changeAmount: '最高转换额度',
    bingQrcode: '绑定谷歌码',
    unboundVerificationCode: '未绑定验证码',
    manipulator: '操作者',
    profitBeforeOperation: '操作前利润',
    profitAfterOperation: '操作后利润',
    operationAmount: '操作金额',
    amountAvailableAfterOperation: '操作后可用金额',
    submissionTime: '提交时间',
    orderNumber: '订单编号',
    rechargeType: '充值类型',
    netwayCode: '充值方式',
    reqStateCode: '请求状态',
    rechargeStateCode: '充值状态',
    createUser: '创建用户',
    rechargeCompleteTime: '充值完成时间',
    founder: '创建人',
    payChannelId: '通道',
    payMerchNo: '通道商户号',
    rechargeCompletionTime: '充值完成时间',
    requestStatusDescription: '请求状态描述',
    agentRemitOrder: '代理现提订单',
    organizationRemitOrder: '企业现提订单',
    remitType: "提现类型",
    withdrawalAmount: '提现金额',
    approvalStatus: '审核状态',
    bankName: '银行名称',
    bankCardNumber: '银行卡号',
    branchName: '支行名称',
    transferVoucher: '转账凭证',
    rejectReason: '拒绝原因',
    availableProfit: '可用利润',
    availableProfitBefore: '操作前可用利润',
    examinationPassed: '审核通过',
    accountName: '开户姓名',
    statisticsDate: '统计日期',
    export: '导出',
    total: '总数',
    totalNumberOfOutbox: '发件箱总条数',
    billingNumberOfOutbox: '发件箱计费条数',
    sortingFailed: '分拣失败',
    toBeSent: '待发送',
    submittedSuccessfully: '提交成功',
    submissionFailed: '提交失败',
    successfullyReceived: '接收成功',
    receiveFailed: '接收失败',
    successRate: '成功率',
    amountOfConsumption: '充值金额',
    amountPerSMSCount: '单条消费金额',
    costValue: '资费',
    agencyProfit: '代理利润',
    upAgencyProfit: '上级代理收益',
    channelCost: '通道成本',
    profit: '利润',
    date: '日期',
    enterpriseMonthlyReport: '企业月报表',
    channelName: '通道名称',
    tiao: '条',
    yuan: '元',
    totalText: '共计',
    platformProfit: '平台利润',
    corporateDailyReport: '企业日报表',
    statistic: '查看统计',
    batchNumber: '批次号',
    operator: '运营商',
    totalDailyReport: '总日报表',
    statistics: '统计信息',
    agentMonthlyReport: '代理月报表',
    sixMonthData: '6个月内总数数据',
    sixMonthDataForApi: '6个月内访问接口次数',
    sixDayData: '6天内总数数据',
    sixDayDataForApi: '6天内访问接口次数',
    numberPool: '号码池',
    usageCount: '使用次数',
    useNumberPool: '使用号码池',
    oldPassword: '原始密码',
    newPassword: '新密码',
    oldPayPassword: '原始支付密码',
    newPayPassword: '新支付密码',
    confirmPayPassword: '确认支付密码',
    loginFailedCount: '登入失败次数',
    conversionAmount: '转换额度',
    withdraw: '提现',
    remitAmount: '提现余额',
    dollar: '元',
    channelMonthlyReport: '通道月报表',
    loginPassword: '登录密码',
    newLoginPassword: '新登录密码',
    smsContent: '消息内容',
    pleaseEnterText: '请输入',
    pleaseChoose: '请选择',
    googleQrCode: '谷歌二维码',
    forceLogoffText: "强制登出",
    removeGoogle: "解绑google二维码",
    bankCode: '银行名称',
    bankBranch: '分行名称',
    bankAccountName: '开户姓名',
    bankAccountNo: '银行卡号',
    availableAmount: '可用金额',
    error: '错误',
    googleVerifyCode: '谷歌验证码',
    lastUseTime: '最后使用时间',
    forceBindGoogleText: "强制绑定谷歌验证码",
    activeUserText: "活跃用户",
    isStoredGoogleText: "谷歌验证码状态",
    notifyUrl: "通知地址",
    channelId: "通道",
    totalSMSText: '总短信数',
    totalChannelText: '总通道数',
    totalChannelOperatorText: '总运营商数',
    totalAgentText: '总代理数',
    totalOrgText: '总企业数',
    consumeAmountDailyExcelText: "资费详情日报表.xlsx",
    consumeAmountMonthlyExcelText: "资费详情月报表.xlsx",
    activeUserTimeRangeText: "活跃用户时间",
    exportActiveUserReportText: "导出活跃用户表",
    activeUserExcelText: "活跃用户表.xlsx",
    weightingOrg: "权重",
    upNotifyTime: "上游通知时间",
    downNotifyTime: "下游通知时间",
    settleTime: "结算时间",
    orderCreateFailCount: "创建失败",
    orderCreateSuccessCount: "创建成功",
    channelSubmitFailCount: "提交失败",
    channelSubmitSuccessCount: "提交成功",
    channelNotifyFailCount: "通知失败",
    channelNotifySuccessCount: "通知成功",
    refundCount: '退款',
    depositedCount: '入账'
  },
  organizationUserSettings: {
    excelFormatText: "报表档案格式",
    rowLimitText: "行数"
  },
  option: {
    manual: '手动',
    automatic: '自动',
    pending: '待审核',
    examinationPassed: '审核通过',
    auditNotPassed: '审核不通过',
    platformRecharge: '平台充值',
    agentRecharge: '代理充值',
    transactionRecharge: '交易充值',
    success: '成功',
    failure: '失败',
    signatureError: '签名错误',
    otherErrors: '其它错误',
    unpaid: '未支付',
    initial: '初始',
    menu: '菜单',
    button: '按钮',
    mainAccount: '主账号',
    subAccount: '子账号',
    pleaseChoose: '请选择',
    templateExemption: '模板免审',
    templateSendOnly: '模板发送',
    manualReview: '人工审核',
    exemption: '免审',
    doNotUse: '不使用',
    use: '使用',
    regular: '正常',
    locking: '锁定',
    invalid: '作废',
    notApproved: '未认证',
    approved: '认证通过',
    rejected: '认证失败',
    donTDealWith: '不处理',
    transferToProcessing: '转入处理',
    alipay: '支付宝',
    alipayHK: '支付宝香港',
    alipayApp: '支付宝App',
    alipayAppHK: '支付宝App香港',
    wechat: '微信',
    wechatHK: '微信香港',
    wechatH5: '微信H5',
    wechatH5HK: '微信香港H5',
    wechatApp: '微信App',
    wechatAppHK: '微信App香港',
    weChatPayMiniProgram: '微信小程序支付',
    AlipayMiniProgramHK: '支付宝小程序HK',
    AlipayMiniProgramCN: '支付宝小程序CN',
    ApplePayCNTest: 'Apple Pay測試',
    GooglePayTest: 'Google Pay測試',
    SecureAcceptanceTest: '信用卡支付測試',
    wechatAppByWeChat: '微信App(微信直营)',
    paypalHK: 'PayPal香港',
    paypalUS: 'PayPal美国',
    applePay: '苹果支付',
    applePayCN: '苹果支付中国',
    googlePay: '谷歌支付',
    secureAcceptance: 'Secure Acceptance',
    cyberSource: 'CyberSource',
    onlineBanking: '网银',
    enterpriseAbolishedAndTransferredIn: '企业作废转入',
    sms: '短信',
    domestic: '国内',
    hongKong: '香港',
    normal: '正常',
    malaysia: '马来西亚',
    chinaHongKong: '中国香港',
    deleteTariff: '删除资费',
    smsContent: '消息内容',
    cancel: "作废",
    CTCC: "电信",
    CMCC: "移动",
    CUCC: "联通",
    unknownChannelOperator: "未知运营商",
    SMS: "短信",
    PSBC: "中国邮政储蓄银行",
    SPDB: "上海浦东发展银行",
    CNCB: "中信银行",
    CIB: "兴业银行",
    HXB: "华夏银行",
    CMBC: "中国民生银行",
    CEB: "中国光大银行",
    CMB: "招商银行",
    BCM: "交通银行",
    CCB: "中国建设银行",
    ICBC: "中国工商银行",
    ABC: "中国农业银行",
    BOC: "中国银行"
  },
  message: {
    h: '时',
    m: '分',
    s: '秒',
    timeDiff: '回执相隔时间',
    titletable: '表格提交',
    title: '我要发送',
    submitByTemplateTitle: '模板提交',
    message1: "将会删除数据。继续？",
    permissionMessage1: "将会删除记录，记录如果包含子记录，也会被一并删除，继续？",
    organizationManagementMessage2: "认证通过已取消",
    message3: "删除已取消",
    organizationManagementMessage4: "删除成功!",
    message5: "删除失败!",
    message6: "添加成功",
    organizationManagementMessage7: "暂停成功",
    organizationManagementMessage8: "暂停失败",
    message9: "认证通过成功",
    message10: "认证通过失败",
    message11: "认证失败成功",
    message12: "认证失败失败",
    organizationManagementMessage13: "密码长度为8到20之间",
    organizationManagementMessage14: "两次密码不一致",
    organizationManagementMessage15: "用户名长度在6到20之间",
    message16: "请至少选择一个数据进行操作！（在数据最左边的复选框打√）",
    organizationManagementMessage17: "非有效电话号码，目前只支持大陆电话",
    message18: "充值成功",
    organizationManagementMessage19: "作废成功",
    organizationManagementMessage20: "资费添加成功",
    organizationManagementMessage21: "資費更新成功",
    message21: "会将认证状态改为认证通过。继续？",
    message22: "会将认证状态改为认证失败。继续？",
    message23: "认证失败已取消！",
    organizationManagementMessage24: "作废失败！",
    message25: "认证通过已取消！",
    message26: "充值失败！",
    organizationManagementMessage27: "将会锁定数据。继续？",
    organizationManagementMessage28: "锁定成功！",
    organizationManagementMessage29: "锁定失败！",
    organizationManagementMessage30: "将会解锁数据。继续？",
    organizationManagementMessage31: "锁定数据已取消。",
    organizationManagementMessage32: "解锁数据已取消。",
    organizationManagementMessage33: "解锁成功。",
    organizationManagementMessage34: "解锁失败。",
    message35: "将会重置密码。继续？",
    message36: "重置密码已取消！",
    message37: "重置密码成功！",
    message38: "重置密码失败！",
    Message39: "请选择一个菜单",
    message40: "添加失败",
    message41: "修改成功",
    message42: "修改失败",
    organizationManagementMessage43: "更新角色权限成功",
    organizationManagementMessage44: "更新角色权限失败",
    message45: "数据未做任何修改",
    message46: "会将审核状态改为审核通过。继续？",
    message47: "会将审核状态改为审核不通过。继续？",
    message48: "审核不通过已取消！",
    message49: "审核通过已取消！",
    message50: "审核通过成功！",
    message51: "审核通过失败！",
    message52: "审核不通过成功！",
    message53: "审核不通过失败！",
    message54: "请选择转账凭证",
    batchNumberText: "批次号",
    phoneNumberText: "手机号码",
    operatorText: "代理商",
    organizationNameText: "企业名称",
    subordinateAgentNameText: "下级代理名称",
    organizationIDText: "企业编号",
    smsContentText: "消息内容",
    informationTypeText: "消息类型",
    auditStatusText: "审核状态",
    submitMethodText: "提交方式",
    messagesDetailText: "信息详情",
    submitTimeText: "提交时间",
    submitterText: "提交人",
    createTimeText: "创建时间",
    amountDetailText: "金额详情",
    updateOrganizationInformationText: "修改信息",
    toText: "至",
    receiveStatusText: "接收状态",
    requestStatusText: "请求状态",
    channelText: "通道",
    statusText: "状态",
    resubmitText: "我要补发",
    totalCustomersText: "总客户数",
    customerUnitText: "家",
    totalRecord: "总记录",
    recordUnitText: "条",
    smsCountMessageText: "计费短信数",
    consumeAmountText: "消费金额",
    consumeAmountWithUnitText: "消费金额",
    channelCostText: "通道成本",
    dollarUnitText: "元",
    subordinateAgentIncomeText: "下级代理利润",
    agentRewardText: "代理利润",
    agentReward2Text: "利润",
    agentRewardWithUnitText: "利润",
    validSMSMessageText: "有效短信数",
    platformRewardText: "平台利润",
    todayMaximumSpeedText: "本日最高流速",
    currentSpeedText: "当前流速",
    expectedCompleteTimeText: "预计完成耗时",
    channelOperatorText: "运营商",
    channelOperatorDetailText: "运营商详情",
    selectBatchMessageResubmitText: "选中批量重发",
    selectBatchMessageResubmitNoticeText: "选中补发通知",
    selectBatchMessageConditionalResubmitText: "条件批量重发",
    selectBatchMessageConditionalResubmitNoticeText: "条件补发通知",
    selectBatchMessageConditionalUpdateReturnSuccessText: "强制回执成功",
    selectBatchMessageConditionalUpdateReturnFailText: "强制回执失败",
    exportMSGIDText: "导出MSGID",
    exportUpstreamSortingFailText: "导出分拣失败报表",
    returnTimeText: "回执时间",
    channelMessageLogoText: "通道消息标识",
    phoneNumberCount: "号码数",
    auditApproveText: "通过审核",
    auditRefuseText: "拒绝审核",
    manualSubmitText: "人工发送",
    manualCancelText: "人工取消",
    agentIDText: "代理商id",
    countryCallingCodesText: "手机号码归属国家编码",
    phoneNumberSetText: "接收的手机号码集合(逗号隔开)",
    phoneNumberCountText: "号码数",
    validMessageNumberText: "有效的短信数",
    messageWordCountText: "短信字数",
    rejectReasonText: "拒绝原因",
    clientIPAddressText: "客户端ip",
    scheduledTimeText: "定时时间",
    sortingTimeText: "分拣时间",
    agentRevenueText: "代理商收益",
    platformRevenueText: "平台收益",
    regionText: "地区",
    operationText: "操作",
    addInformationText: "新增信息",
    addChannelText: "新增通道",
    createSimilarChannelText: "创建类似通道",
    updateChannelText: "更新通道",
    addPayChannelText: "新增支付通道",
    updatePayChannelText: "更新支付通道",
    addTemplateText: "新增模板",
    updateTemplateText: "更新模板",
    numberRegionText: "号码区域",
    addSensitiveWordText: "新增敏感词",
    sensitiveWordText: "敏感词",
    sensitiveWordDocumentText: "敏感词文件",
    supportFormatMessage: "(支持文件格式:txt)",
    templateNameText: "模板名称",
    templateVariableText: "动态内容",
    templateVariableLocationText: "动态内容位置",
    templateVariableRemarkText: "动态内容备注",
    templateVariableRemarkMessage: "以[]为动态内容位置，短信内容必须与所有非动态内容（包括空格、符号和位置）相同",
    templateVariableExampleText: "动态内容例子",
    templateVariableExampleMessage1: "示例：验证码模板＃您的验证码：[0]，请勿告知他人！不可时间[1]分钟！",
    templateVariableExampleMessage2: "实际可发短信内容：验证码模板＃您的验证码：123456，请勿告知他人！不可时间5分钟！",
    templateContentText: "模板内容",
    descriptionText: "描述",
    updateInformationText: "修改信息",
    totalText: "共计",
    submitSuccessText: "提交成功",
    submitFailText: "提交失败",
    receiveSuccessText: "接收成功",
    receiveFailText: "接收失败",
    receiveUnknownText: "接收未知",
    sortingFailText: "分拣失败",
    waitingSubmitText: "等待提交",
    successRateText: "成功率",
    mobileSuccessRateText: "移动成功率",
    sendBoxExcelText: "发件箱.xlsx",
    sendBoxHistoryExcelText: "历史发件箱.xlsx",
    sendRecordExcelText: "发送记录信息表.xlsx",
    sendRecordHistoryExcelText: "历史发送记录信息表.xlsx",
    returnRecordExcelText: "发送回执信息表.xlsx",
    returnRecordHistoryExcelText: "历史发送回执信息表.xlsx",
    message55: "登录已失效，请重新登录",
    message56: "对不起，您暂无该操作权限",
    message57: "密码修改成功",
    message58: "请填写正确的域名",
    message59: "添加系统配置成功",
    message60: "将文件拖到此处，或",
    message61: "点击上传",
    message62: "只能上传jpg/png文件，且不超过5120Kb",
    message63: "提示：手机扫码后请输入谷歌码及支付密码，提交成功以完成谷歌绑定！",
    submitDetailText: "提交详情",
    returnDetailText: "接收详情",
    numberDocumentText: "号码文件",
    dynamicVariableDocumentText: "动态内容参数文件",
    splitNumberText: '批次号码数',
    remarkSplitNumberMessage: '短信内容跟据批次号码数生成批次并替换动态内容。如果批次号码数是500，每500个号码替换一次动态内容，直到所有号码处理完毕',
    remarkSplitNumberLimitMessage: "批次号码数最少需要设为500或500的倍数",
    remarkDynamicVariableInContentMessage: "以##A##为动态内容位置。如果内容没有'##A##'会提交失败",
    remarkDynamicVariableInContentExampleMessage: "如果内容是 '你好，##A##' 和动态内容是 '世界'，最后短信内容为 '你好，世界'。",
    smsMessageContentText: "短信内容",
    smsMessageTemplateContentText: "模板短信内容",
    wordCountText: "字数统计",
    scheduledSubmitText: "定时发送",
    remarkText: "注意",
    remarkEnterNumberMessage: "(多个号码换行或者逗号分割,最多5W个号码)",
    remarkSMSNumberLimitMessage: "最少需要上传500条号码",
    remarkNumberDocumentMessage: "(每个文件最大支持5W个号码换行或者逗号分割。支持文件格式:txt)",
    remarkDynamicVariableDocumentMessage: "(动态内容参数数量和分割后批次量需要一致，不同数量会提交失败。支持文件格式:txt)",
    remarkScheduledSendMessage: "(不填为即时发送)",
    remarkIsStoredScheduledTimeMessage: "(不选为提交后清除定时时间)",
    clearScheduledTimeMessage: "清除定时时间",
    notClearScheduledTimeMessage: "不清除定时时间",
    // sendBoxClearScheduledTimeMessage: "发件箱记录清除定时时间",
    // sendBoxNotClearScheduledTimeMessage: "发件箱记录不清除定时时间",
    totalWordCountText: "个字符",
    separateText: ",拆分",
    totalMessageText: "条短信",
    remarkReminderMessage: "包含签名短信小于等于70个字的按70个字一条计费，大于70个字按67字一条计费, 短信内容总字数不能超过 500字",
    tableRemarkNumberDocumentMessage1: "(第一行默认为标题不被导入,第一列必须是手机号码。",
    tableRemarkNumberDocumentMessage2: "文件大小不超过2M，支持文件格式:Excel2003(xls),Excel2007(xlsx))",
    tableRemarkNumberDocumentMessage3: "点击此处查看表格提交说明示例",
    numberDocumentListText: "列",
    exampleText: "示例说明",
    viewSMSNumbersText: "查看号码",
    viewStatusDescText: "通道请求返回信息",
    downloadSMSNumbersText: "下载号码",
    message64: "重置密码为",
    message65: "重置密码为(1234Qwer)!",
    importTemplateText: "模板导入",
    importTemplateRemark1Message: "说明：每个模板占用一行数据,多个模板必须换行！",
    importTemplateRemark2Message: "每行数据格式为：模板名称 + # + 模板内容",
    importTemplateRemark3Message: "示例：验证码模板#您的验证码:{0},请勿告知他人!失效时间{1}分钟!",
    importTemplateRemark4Message: "支持文件格式: txt",
    selectDocumentText: "选择文件",
    sendBoxCreateTime: "发件箱时间",
    sendRecordCreateTime: "发送记录时间",
    message66: '绑定谷歌码',
    cancelScheduleText: "取消定时",
    message67: '转换额度成功',
    message68: '提现审核中',
    message69: '转账凭证不能为空',
    message70: '使用密码池成功',
    message71: '支付密码修改成功',
    message72: '用户名长度为6到20',
    message73: '支付密码长度为8到20',
    message74: '用户名不能为中文（包括中文符号）',
    message75: '邮箱不能为中文（包括中文符号）',
    message76: '用户名长度为6到20',
    message77: "提示：手机扫码后请输入谷歌码及登入密码，提交成功以完成谷歌绑定！",
    provinceNameText: "归属地",
    countryNameText: "国际地区",
    internationalChannelOperatorNameText: "国际营运商",
    submitMessageText: "立即发送",
    cancelMessageText: "取消定时",
    submitByFormText: "我要发送",
    submitByExcelText: "表格提交",
    submitByTemplateText: "模板提交",
    noUseNumberReportText: "没效号码导出",
    sendBoxNoUseNumberExcelText: "发件箱没效号码.xlsx",
    errorUnauthorized: "授权失败： 请重新加载页面以重连服务器。若已试上述方法，请联络管理员。",
    errorNetwork: "网络波动，请重新提交或者重新登录后进行操作。",
    smsNumbersType: "号码类型",
    pleaseSelectCostNameText: "请选择资费名称",
    pleaseSelectCountryNameText: "请选择国际地区",
    paySuccess: "支付成功!",
    payFailure: "支付失败!",
    ifItDidNotRedirect: '如无自动跳转，请手动关闭浏览器'
  },
  monitor: {
    operatorText: "操作人",
    operatorType: "操作者类型",
    operationTimeText: "操作时间",
    operationDescriptionText: "操作描述",
    elapsedTimeText: "耗时",
    operationMethodText: "操作方法",
    methodParameterText: "方法参数",
    IPAddressText: "IP地址",
    operationLocationText: "操作地点",
    createTimeText: "创建时间",
    loginUserText: "登录用户",
    loginTimeText: "登录时间",
    operationText: "操作",
    loginLocationText: "登录地点",
    loginSystemText: "登录系统",
    loginBrowserText: "浏览器"
  },
  job: {
    content: "内容",
    sendCode: "批次号",
    beanNameText: "Bean名称",
    methodNameText: "方法名称",
    statusText: "状态",
    taskIDText: "任务ID",
    methodParameterText: "方法参数",
    cronExpressionText: "cron表达式",
    remarkText: "备注",
    createTimeText: "创建时间",
    operationText: "操作",
    abnormalInformationText: "异常信息",
    elapsedTimeText: "耗时",
    executedTimeText: "执行时间",
    updateInformationText: "更新信息",
    addJobText: "新增任务",
    updateJobText: "修改任务",
    deleteJobText: "删除任务",
    batchDeleteJobText: "批量删除任务",
    pauseJobText: "暂停任务",
    resumeJobText: "恢复任务",
    runJobText: "执行任务",
    exportExcelText: "导出Excel",
    scheduledTaskExcelText: "任务表.xlsx",
    jobOperationText: "任务操作"
  },
  agent: {
    agentNameText: "代理名称",
    agentIdText: "代理ID",
    channelText: "通道",
    channelNameText: "通道名称",
    payChannelName: "支付通道",
    payMethod: "支付方式",
    costNameText: "资费名称",
    channelOperatorText: "通道运营商",
    costParam: "佣金比例",
    costRatio: "佣金参数比例",
    costText: "佣金",
    minimumAmount: "最小额度",
    statusText: "状态",
    areaNumberText: "地区区号",
    smsTypeText: "短信类型",
    weightingText: "权重",
    numberRandomText: "随机主叫",
    numberFixationText: "固定主叫",
    descriptionText: "描述",
    remarkText: "备注",
    copyAgentCostText: "复制资费",
    sourceAgentNameText: "代理资费来源",
    targetAgentNameText: "目标代理"
  },
  organization: {
    channelText: "通道",
    channelNameText: "通道名称",
    costNameText: "资费名称",
    channelOperatorText: "通道运营商",
    costText: "资费",
    minimumAmount: "最小额度",
    statusText: "状态",
    areaNumberText: "地区区号",
    smsTypeText: "短信类型",
    weightingText: "权重",
    numberRandomText: "随机主叫",
    numberFixationText: "固定主叫",
    descriptionText: "描述",
    remarkText: "备注",
    organizationNameText: "企业名称",
    organizationCodeText: "企业编码",
    copyOrganizationCostText: "复制资费",
    sourceOrganizationNameText: "企业资费来源",
    targetOrganizationNameText: "目标企业",
    changeAgentText: "转移代理",
    originAgentNameText: "原代理",
    targetAgentNameText: "目标代理",
    viewOrgDetailText: '对接详情'
  },
  channel: {
    operatorText: "操作人",
    lastLoginTimeText: "最后使用时间",
    channelIdText: "通道编号",
    channelNameText: "通道名称",
    protocolTypeText: "协议类型",
    enableChannelText: "通道状态",
    configurePropertyText: "配置属性",
    configureCostText: "配置资费",
    testingChannelText: "测试通道",
    numberPoolText: "号码池",
    updateNumberPoolText: "更新号码池",
    fixedCallingNumberText: "固定主叫号",
    updateFixedCallingNumberText: "更新固定主叫号",
    connectionStatusText: "连接状态",
    implementClassText: "实现类",
    waitingSubmitAmountText: "等待发送数量",
    remainingSubmitAmountText: "剩余发送数量",
    failNumberAmountText: "失效号码数量",
    weightingText: "权重",
    remarkText: "备注",
    creatorText: "创建人",
    channelCodeText: "通道代码",
    regionRestrictionText: "地区限制",
    operatorRestrictionText: "运营商限制",
    combinedRestrictionText: "组合限制",
    supportRegionText: "支持地区",
    descriptionText: "描述",
    dailyMaximumSubmitAmountText: "每天最大发送量",
    IPAddressText: "ip地址",
    portText: "端口",
    APINumberText: "接口号",
    passwordText: "密码",
    APITypeText: "接口类型",
    versionText: "版本号",
    codingTypeText: "编码类型",
    codingSchemeText: "编码方案",
    connectionNumberText: "连接数",
    speedText: "速率(条/秒)",
    deliveredSpeedText: "分发速率(条/秒)",
    channelPropertyText: "通道属性(",
    protocolText: "协议)",
    smsTypeText: "短信类型",
    costNameText: "资费名称",
    costText: "资费",
    channelOperatorText: "通道运营商",
    attributeValueText: "属性值",
    organizationCodeText: "商户号",
    gatewayTypeText: "网关类型",
    channelStatusText: "通道状态",
    settleDayText: "结算日",
    minimumAmountText: "最小金额",
    maximumAmountText: "最大金额",
    requestUrlText: "提交url",
    channelCostText: "通道成本",
    callbackUrlText: "回调url",
    tradeIDText: "交易编码",
    signatureKeyText: "签名秘钥",
    encryptedKeyText: "安全秘钥",
    groupNameText: "分组名称",
    addGroupText: "新增分组",
    updateGroupText: "更新分组",
    updateGroupMemberText: "更新分组明细",
    organizationText: "商户",
    organizationNameText: "企业名称",
    smsChannelGroupNameText: "通道分组名称",
    smsChannelGroupStateText: "通道分组状态",
    configureChannelText: "配置通道",
    addOrganizationCostText: "配置企业资费",
    configureGroupCostText: "配置资费組合",
    configureGroupCostMemberText: "配置企业资费組合",
    forceOperation: '强制执行',
    channelOperationText: "通道操作",
    addChannelText: "新增通道",
    batchDeleteChannelText: "批量删除通道",
    startChannelText: "启动通道",
    pauseChannelText: "暂停通道",
    disableChannelText: "停止通道",
    copyChannelCostText: "复制资费",
    sourceChannelNameText: "通道资费来源",
    targetChannelNameText: "目标通道",
    batchUpdateCostText: "批量更新资费",
    batchUpdateAllCostText: "批量更新全部资费",
    payChannelId: "支付通道ID",
    payChannelNameText: "支付通道名称",
    currencyText: "货币",
    netwayCodeText: "支付方法",
    defaultCurrencyText: "默认货币",
    minAmountText: "最少充值金额",
    currencyFromText: "转换前货币",
    currencyToText: "转换后货币",
    currencyRateText: "汇率",
    currencyExchangeRateUpdateStateText: "汇率API更新状态",
    updateTimeText: "更新时间",
    addCurrencyExchangeRateText: "新增货币汇率",
    updateCurrencyExchangeRateText: "更新货币汇率",
    batchUpdateCurrencyExchangeRateText: "批量更新货币汇率",
    createSimilarChannelText: "创建类似通道"
  },
  warningMessage: {
    updateInformationMessage: "请选择需要修改的记录",
    selectRecordToDeleteMessage: "请选择需要删除的记录",
    deleteRecordMessage: "删除记录",
    deleteRecordConfirmMessage: "确定删除该记录？",
    selectPhoneToDeleteMessage: "请选择需要删除的手机号码",
    deletePhoneMessage: "删除手机号码",
    deletePhoneConfirmMessage: "确定删除手机号码",
    batchDeletePhoneMessage: "批量删除手机号码",
    batchDeletePhoneConfirmMessage: "确定批量删除手机号码？",
    selectSensitiveWordToDeleteMessage: "请选择需要删除的敏感词",
    deleteSensitiveWordMessage: "删除敏感词",
    deleteSensitiveWordConfirmMessage: "确定删除敏感词",
    batchDeleteSensitiveWordMessage: "批量删除敏感词",
    batchDeleteSensitiveWordConfirmMessage: "确定批量删除该敏感词？",
    deleteRecordSuccessMessage: "删除成功",
    addInformationSuccessMessage: "新增数据成功",
    selectRecordToResubmitMessage: "请选择需要重发的记录",
    enterValidParamToResubmitMessage: "请输入正确搜寻条件",
    resubmitSMSMessage: "确定补发",
    resubmitSMSMessage2: "该短信？",
    resubmitSMSTitle: "补发短信",
    resubmit2RecordTitle: "补发记录",
    resubmit2RecordRemarkMessage: "确定补发该记录？",
    selectRecordToResubmitNoticeMessage: "请选择需要补发通知的记录",
    resubmitRemarkNoticeTitle: "补发通知回调",
    resubmitRemarkNoticeMessage: "确定补发状态通知？状态非【分拣失败/接收成功/接收失败】的记录将不被补发！",
    resubmitRemarkTitle: "重发记录",
    resubmitRemarkMessage: "确定重发该记录？状态非【等待提交/提交失败】的记录将不被重发！",
    conditionalUpdateRemarkTitle: "强制执行",
    conditionalUpdateRemarkMessage: "修改发送记录状态",
    selectRecordToAuditMessage: "请选择需要审核的记录",
    auditRecordMessage: "审核记录",
    auditRecordConfirmMessage: "确定审核该记录？",
    refuseReasonConfirmMessage: "输入拒绝原因，并确认",
    auditSuccessMessage: "审核成功",
    cannotBeEmpty: "不能为空",
    enterChannelNameMessage: "请输入通道名称",
    enterChannelCodeMessage: "请输入通道代码",
    enterWeightingMessage: "请输入权重值，数值越高，权重越大",
    enterImplementClassMessage: "请输入通道实现类",
    enterRegionRestrictionRegexMessage: "请输入地区限制正则表达式",
    enterOperatorRestrictionRegexMessage: "请输入运营商限制正则表达式",
    enterCombinedRestrictionRegexMessage: "请输入地区运营商组合限制正则表达式",
    enterDescriptionMessage: "请输入描述",
    enterDailySubmitAmountMessage: "请输入每天发送量",
    pleaseSelectOneChannelMessage: "请选择一个通道",
    configureChannelPropertyMessage: "请选择需要配置属性的通道",
    configureChannelCostMessage: "请选择需要配置资费的通道",
    updatePropertyMessage: "修改配置属性",
    updateCostMessage: "修改资费属性",
    addJobConfirmMessage: "确定新增任务？",
    addJobSuccessMessage: "新增任务成功",
    selectJobToDeleteMessage: "请勾选需要删除的任务",
    deleteJobConfirmMessage: "确定删除所选任务？",
    deleteJobSuccessMessage: "删除任务成功",
    selectJobToPauseMessage: "请勾选需要暂停的任务",
    pauseJobConfirmMessage: "确定暂停所选任务？",
    pauseJobSuccessMessage: "暂停任务成功",
    selectJobToResumeMessage: "请勾选需要恢复的任务",
    resumeJobConfirmMessage: "确定恢复所选任务？",
    resumeJobSuccessMessage: "恢复任务成功",
    selectJobToRunMessage: "请勾选需要执行的任务",
    runJobConfirmMessage: "确定执行所选任务？",
    runJobSuccessMessage: "执行任务成功",
    enterNumberMessage: "请输入手机号码或上载号码文件",
    uploadDynamicVariableDocumentMessage: "请上载号码文件",
    channelCostExistMessage: "资费已经存在,请勿重新添加",
    selectGroupToUpdateMessage: "请选择需要更新的分组",
    selectUpdateTemplateMessage: "请选择需要修改的模板",
    selectMessageToDeleteMessage: "请选择需要取消定时的短讯",
    cancelScheduleRemarkMessage: "是否立即发送？",
    cancelScheduleRemarkForConfirmMessage: "立即发送: 立即发送【通过审核的】发件箱",
    cancelScheduleRemarkForCancelMessage: "取消定时: 取消定时，不再发送",
    cancelScheduleSuccessMessage: "取消定时成功",
    addSensitiveWordSuccessMessage: "新增敏感词成功",
    sensitiveWordNoInputMessage: "没有输入敏感词或上载敏感词文件",
    addPhoneNumberBlackListText: '新增手机黑名单',
    addBlackListSuccessMessage: '新增手机黑名单成功',
    addTemplateSuccessMessage: '新增模板成功',
    importTemplateSuccessMessage: '导入模板成功',
    updateTemplateSuccessMessage: '更新模板成功',
    deleteTemplateMessage: '删除模板',
    deleteTemplateConfirmMessage: '确定删除该模板？',
    updateJobSuccessMessage: "更新任务成功",
    deleteGroupMessage: "删除分组",
    deleteGroupConfirmMessage: "确定删除该分组？",
    updateGroupMessage: "更新分组",
    updateGroupConfirmMessage: "确定更新该分组?",
    addGroupSuccessMessage: "新增分组成功",
    updateGroupSuccessMessage: "更新分组成功",
    updateGroupDetailSuccessMessage: "更新分组明细成功",
    updateGroupStatusSuccessMessage: "更新分组状态成功",
    selectChannelToDeleteMessage: "请选择需要删除的通道",
    deleteChannelMessage: "删除通道",
    deleteChannelConfirmMessage: "确定删除该通道？",
    selectChannelToStartMessage: "请选择需要启动的通道",
    startChannelMessage: "启动通道",
    startChannelConfirmMessage: "确定启动该通道？",
    startChannelSuccessMessage: "启动通道成功",
    selectChannelToPauseMessage: "请选择需要暂停的通道",
    pauseChannelMessage: "暂停通道",
    pauseChannelConfirmMessage: "确定暂停该通道？",
    pauseChannelSuccessMessage: "暂停通道成功",
    selectChannelToDisableMessage: "请选择需要停止的通道",
    disableChannelMessage: "停止通道",
    disableChannelConfirmMessage: "确定停止该通道？",
    disableChannelSuccessMessage: "停止通道成功",
    addChannelSuccessMessage: "新增通道成功",
    updateChannelSuccessMessage: "更新通道成功",
    deleteChannelSuccessMessage: "删除通道成功",
    addChannelPropertySuccessMessage: "新增通道属性成功",
    updateChannelPropertySuccessMessage: "更新通道属性成功",
    updateNumberPoolSuccessMessage: "更新号码池成功",
    updateNumberFixationSuccessMessage: "更新固定主叫号成功",
    addChannelCostSuccessMessage: "新增通道资费成功",
    updateChannelCostSuccessMessage: "更新通道资费成功",
    deleteChannelCostMessage: "删除通道资费",
    deleteChannelCostConfirmMessage: "确定删除该通道资费？",
    addPayChannelSuccessMessage: "新增支付通道成功",
    updatePayChannelSuccessMessage: "更新支付通道成功",
    selectPayChannelToDeleteMessage: "请选择需要删除的支付通道",
    selectPayChannelToCopy: "请选择需要一个复制的支付通道",
    deletePayChannelMessage: "删除支付通道",
    deletePayChannelConfirmMessage: "确定删除该支付通道？",
    deletePayChannelSuccessMessage: "删除支付通道成功",
    submitSMSMessage: "发送短信",
    submitSMSConfirmMessage: "确定发送该短信？",
    submitScheduledSMSMessage: "发送定时短信",
    submitScheduledSMSConfirmMessage: "确定发送该定时短信？",
    fileExceedMessage: "上传文件超过上限",
    fileExceedLimitMessage: "文件数量上限是",
    fileSizeExceedMessage: "上传文件大小超过上限",
    fileSizeExceedLimitMessage: "文件大小上限是",
    submitSMSSuccessMessage: "成功发送短信",
    submitScheduledSMSSuccessMessage: "成功发送定时短信",
    uploadInvalidFileFormatMessage: "上传文件格式不合符要求，请重新上传",
    forceLogoffMessage: "强制登出用户",
    forceLogoffConfirmMessage: "确定强制登出该用户？",
    forceLogoffSuccessMessage: "强制登出用户成功",
    removeGoogleMessage: "解绑用户google二维码",
    removeGoogleConfirmMessage: "确定解绑该用户google二维码？",
    removeGoogleSuccessMessage: "解绑google二维码成功",
    selectUserToUpdatePermissionMessage: "请选择需要更新的用户",
    updatePermissionMessage: "更新用户权限",
    updatePermissionConfirmMessage: "确定更新该用户权限？",
    updatePermissionSuccessMessage: "更新用户权限成功",
    batchUpdatePermissionMessage: "批量更新用户权限",
    batchUpdatePermissionConfirmMessage: "确定批量更新该用户权限？",
    batchUpdatePermissionSuccessMessage: "批量更新用户权限成功",
    selectBlackListToDeleteMessage: "请选择需要删除的黑名单",
    deleteBlackListMessage: "删除黑名单",
    deleteBlackListConfirmMessage: "确定删除该黑名单",
    deleteBlackListSuccessMessage: "删除黑名单成功",
    passwordFormatNoUpperMessage: "密码须有最少一个大阶英文字母",
    batchCancelAgentConfirmMessage: "确认批量作废代理？",
    cancelAgentCancelledMessage: "作废代理已取消",
    cancelAgentSuccessMessage: "作废代理成功!",
    cancelOrganizationConfirmMessage: "确认作废企业？",
    cancelOrganizationConfirmRemarkMessage: "该企业附属所有企业用户皆会作废。",
    batchCancelOrganizationConfirmMessage: "确认批量作废企业？",
    batchCancelOrganizationConfirmRemarkMessage: "所选企业附属所有企业用户皆会作废。",
    cancelOrganizationCancelledMessage: "作废企业已取消",
    cancelOrganizationSuccessMessage: "作废代理成功!",
    cancelOrganizationRemarkMessage: "批量操作默认不处理剩余可用金额。",
    cancelOrganizationRemarkMessage1: "如需要转移可用金额于对应代理，请单次处理作废企业。",
    deleteAgentSystemConfigMessage: "删除代理配置",
    deleteAgentSystemConfigConfirmMessage: "确定删除代理配置",
    deleteAgentSystemConfigSuccessMessage: "删除代理配置成功",
    selectTemplateToSubmitMessage: "请选择需要发送短信的模板",
    pleaseSelectOneTemplateMessage: "请选择一个模板",
    pleaseSelectValidTemplateMessage: "请选择审核状态为审核通过的模板",
    pleaseEnterBatchNumberMessage: "请输入批次号",
    pleaseSelectLatestSevenDaysMessage: "请选择最近7天",
    selectExcelToDownloadMessage: "请选择需要下载的报表",
    pleaseWaitForExportMessage: "已接受指令，正在处理数据，导出需时，请耐心等侯。(导出50W条数据约需1分钟。)",
    pleaseWaitForExportAndNavigateMessage: "已接受指令，正在处理数据，报表可于 '报表管理/导出报表' 下载。 (生成50W条数据约需50秒。)",
    pleaseWaitForExportAndNavigateTitle: "导出报表提示",
    exportAndNavigateConfirmButtonText: "前往",
    exportAndNavigateCancelButtonText: "已读",
    selectExcelToDeleteMessage: "请选择需要删除的报表",
    deleteExcelMessage: "删除报表",
    deleteExcelConfirmMessage: "确定删除报表",
    batchDeleteExcelMessage: "批量删除报表",
    batchDeleteExcelConfirmMessage: "确定批量删除该报表？",
    excelFormatRemarkMessage1: "xls格式行数上限为65536, 支援 MS 2003 Excel 或之前版本 ",
    excelFormatRemarkMessage2: "xlsx格式行数上限为1048576, 不支援 MS 2003 Excel 或之前版本 ",
    excelFormatRemarkMessage3: "默认为xlsx格式及行数50W",
    invalidRowLimitMessage: "错误报表行数",
    currentExcelSettingMessage: "现在使用的报表配置:",
    defaultExcelSettingMessage: "默认配置",
    addExcelSettingSuccessMessage: "添加报表配置成功",
    addExcelSettingFailMessage: "添加报表配置失败",
    pleaseWaitForProcessMessage: "已接受指令，正在处理，请耐心等侯。",
    pleaseWaitForProcessSendBoxSubmitMessage: " 后台正在处理，请稍等！注意查看发件箱！",
    pleaseWaitForPreviewContentMessage: "正在准备预览内容，请耐心等候。",
    channelGroupAddMemberRemark: "一个企业只可以加入一个分组。加入分组时，会删除该企业全部资费。如果企业已加入其他分组，会删除前分组的资费。资费组合状态和权重会跟随对应通道。",
    channelGroupDeleteMemberRemark: "删除企业时，该企业在该分组中所有资费都会被删除。",
    channelGroupAddChannelRemark: "分组可以加任意通道，在该分组中所有企业都会增加新通道的资费。",
    channelGroupDeleteChannelRemark: "删除通道时，在该分组中所有企业都会删除对应通道的资费。",
    channelGroupDeleteGroupRemark: "删除分组时，所有该分组中所有企业的资费都会被删除。",
    channelGroupAddCostRemark: "分组可以加任意资费组合，在该分组中所有企业都会增加新资费组合。资费组合状态和权重会跟随对应通道。",
    channelGroupAddCostMemberRemark: "一个企业只可以加入一个分组。加入分组时，会删除该企业全部资费。如果企业已加入其他分组，会删除前分组的资费。",
    channelGroupDeleteCostRemark: "删除资费组合时，在该分组中所有企业都会删除对应资费组合。",
    channelGroupDeleteCostMemberRemark: "删除企业时，该企业会删除在该分组中所有的资费组合。亦不会删除分组以外的资费。",
    selectChannelGroupMemberMessage: "请选择企业资费",
    selectChannelGroupCostMessage: "请选择资费组合",
    pleaseSelectSourceOrganizationAndTargetOrganizationMessage: "请选择企业资费来源和目标企业",
    copyOrganizationCostSuccessMessage: "复制企业资费成功!",
    copyOrganizationCostRemark: "复制资费时，所有目标企业的资费都会被删除。",
    pleaseSelectTargetOrganizationAndTargetAgentMessage: "请选择目标企业和目标代理",
    changeAgentSuccessMessage: "转移代理成功!",
    changeAgentRemark: "转移代理时，所有目标企业的资费都会被删除。如目标企业已加入通道分组，会强制退出通道分组。",
    pleaseSelectSourceAgentAndTargetAgentMessage: "请选择代理资费来源和目标代理",
    copyAgentCostSuccessMessage: "复制代理资费成功!",
    copyAgentCostRemark: "复制资费时，所有目标代理的资费都会被删除。",
    pleaseSelectSourceChannelAndTargetChannelMessage: "请选择通道资费来源和目标通道",
    copyChannelCostSuccessMessage: "复制通道资费成功!",
    copyChannelCostRemark: "复制资费时，所有目标通道的资费都会被删除。",
    updateTemplateRemarkTitle: "更新模板",
    updateTemplateRemarkMessage: "模板发送用户更新模板内容时，模板审核状态会设置为待审核",
    selectOrganizationMessage: "请选择企业",
    selectOneOrganizationMessage: "请选择一位企业",
    HTTPAndSMPPNotAvailableMessage: "未开通SMPP或HTTP接口",
    addCurrencyExchangeRateSuccessMessage: "新增货币汇率成功",
    updateCurrencyExchangeRateSuccessMessage: "更改货币汇率成功",
    selectCurrencyExchangeRateToUpdateMessage: "请选择需即时更新的货币汇率",
    updateCurrencyExchangeRateTitle: "即时更新货币汇率",
    updateCurrencyExchangeRateMessage: "确定即时更新货币汇率？所有已选的货币汇率都会即时更新，包括更新状态为手动更新的货币汇率!"
  },
  auditOptionsText: {
    waitForAuditText: "待审核",
    auditVerifiedText: "审核通过",
    auditNotVerifiedText: "审核不通过",
    manualAuditText: "人工审核"
  },
  informationOptionsText: {
    smsMessageText: "短信"
  },
  statusOptionsText: {
    normalText: "正常",
    pauseText: "暂停",
    sortingFailText: "分拣失败",
    waitingSubmitUpstreamText: "等待提交",
    submitSuccessText: "提交成功",
    submitFailText: "提交失败",
    receiveSuccessText: "接收成功",
    receiveFailText: "接收失败"
  },
  submitMethodOptionText: {
    backendSubmitText: "商户后台",
    httpSubmitText: "http接口",
    smppSubmitText: "smpp接口"
  },
  submitNumberMethodOptionText: {
    submitByFormText: "普通表单提交",
    submitByExcelTemplateText: "excel模板提交"
  },
  numberRegionOptionsText: {
    china: "国内",
    hongKong: "香港",
    international: "国际"
  },
  smsChannelNameOptionText: {
    httpProtocolText: "http协议",
    smppProtocolText: "smpp协议"
  },
  smsChannelStatusOptionText: {
    enableText: "启动",
    pauseText: "暂停",
    disableText: "停止"
  },
  smsChannelConnectionStatusOptionText: {
    connectionSuccessText: "已连接",
    connectionFailText: "未连接"
  },
  forceBindGoogleOptionText: {
    freeText: "非强制绑定",
    forceText: "强制绑定"
  },
  storedGoogleStatusOptionText: {
    noneText: "未绑定",
    storedText: "已绑定"
  },
  checkNumberCountOptionText: {
    noAuditText: "不需审核",
    auditText: "需要审核"
  },
  activeUserOptionText: {
    activeText: "活跃用户",
    inactiveText: "非活跃用户"
  },
  booleanStateOptionText: {
    noText: "否",
    yesText: "是"
  },
  googleCodeRemarkMessage: {
    googleCodeRemarkTitle: "绑定谷歌验证码提醒",
    googleCodeRemarkMessage: "请绑定谷歌验证码，下次登录必须使用谷歌验证码。",
    confirmButtonText: "立即绑定",
    cancelButtonText: "已读"
  },
  serverNotRespond: {
    serverNotRespondTitle: "",
    serverNotRespondMessage: "服务器没有响应，将重定向到登录页面",
    confirmButtonText: "重新登入"
  },
  loginBlackList: {
    roleText: "身份",
    agentText: "代理",
    agentNameText: "代理名称",
    organizationUserText: "企业用户",
    organizationUserNameText: "企业用户名称"
  },
  exportedExcel: {
    userNameText: "用户名",
    roleText: "身份",
    serviceNameText: "应用名称",
    fileNameText: "文件名称",
    statusText: "状态",
    remarkText: "备注",
    creatorText: "创建人",
    createTimeText: "创建日期",
    updateExportedExcelTitle: "更新报表备注",
    downloadText: "下载",
    batchDownloadText: "批量下载"
  },
  exportedExcelServiceName: {
    sendBoxNoUseNumber: "没效号码报表",
    sendBox: "发件箱",
    sendRecord: "发送记录",
    returnRecord: "回执记录",
    sendBoxHistory: "历史发件箱",
    sendRecordHistory: "历史发送记录",
    returnRecordHistory: "历史回执记录",
    statisticalAgent: "代理日报表",
    statisticalMonAgent: "代理月报表",
    statisticalChannel: "通道日报表",
    statisticalMonChannel: "通道月报表",
    statisticalChannelOperator: "通道运营商日报表",
    statisticalMonChannelOperator: "通道运营商月报表",
    statisticalConsumeAmount: "资费详情日报表",
    statisticalMonConsumeAmount: "资费详情月报表",
    statisticalOrgCode: "企业日报表",
    statisticalMonOrgCode: "企业月报表",
    statisticalGeneral: "综合日报表",
    statisticalRateSuccess: "批次成功率",
    statisticalTotalDaily: "总日报",
    statisticalAllConsumeAmount: "全部资费日报表",
    statisticalMonAllConsumeAmount: "全部资费月报表",
    MSGID: "MSGID",
    sortingFail: "分拣失败报表"
  },
  placeholder: {
    verificationCode: "请输入谷歌验证码"
  },
  roleOptionsText: {
    adminText: "管理员",
    agentText: "代理",
    organizationText: "企业"
  },
  excelStatusOptionsText: {
    availableText: "可下载",
    unavailableText: "锁定"
  },
  excelFormatOptionText: {
    xls: "xls",
    xlsx: "xlsx"
  },
  smsNumberTypeOptionText: {
    formSubmitText: "普通表单提交",
    excelSubmitText: "excel模板提交"
  },
  numberAreaProvince: {
    BeiJing: "北京",
    Tianjin: "天津",
    HeBei: "河北",
    LiaoNing: "辽宁",
    JiLin: "吉林",
    HeiLongJiang: "黑龙江",
    ShanDong: "山东",
    JiangSu: "江苏",
    ShangHai: "上海",
    ZheJiang: "浙江",
    AnHui: "安徽",
    FuJian: "福建",
    JiangXi: "江西",
    GuangDong: "广东",
    GuangXi: "广西",
    HaiNan: "海南",
    HeNan: "河南",
    HuNan: "湖南",
    HuBei: "湖北",
    ShanXi: "山西",
    NeiMengGu: "内蒙古",
    NingXia: "宁夏",
    QingHai: "青海",
    ShanXiS: "陕西",
    GanSu: "甘肃",
    XinJiang: "新疆",
    SiChuan: "四川",
    GuiZhou: "贵州",
    YunNan: "云南",
    ChongQing: "重庆",
    XiZang: "西藏"
  },
  smsNumberArea: {
    UnitedStates: "美国",
    Canada: "加拿大",
    CanadaAndUnitedStates: "加拿大/美国",
    China: "中国内地",
    HongKong: "香港",
    Macao: "澳门",
    Taiwan: "台湾",
    Malaysia: "马来西亚",
    Indonesia: "印度尼西亚",
    Philippines: "菲律宾",
    Singapore: "新加坡",
    Thailand: "泰国",
    Brunei: "文莱",
    Japan: "日本",
    SKorea: "韩国",
    Vietnam: "越南",
    NKorea: "朝鲜",
    Cambodia: "柬埔寨",
    Laos: "老挝",
    Bangladesh: "孟加拉国",
    Turkey: "土耳其",
    India: "印度",
    Pakistan: "巴基斯坦",
    Afghanistan: "阿富汗",
    SriLanka: "斯里兰卡",
    Myanmar: "缅甸",
    Maldives: "马尔代夫",
    Lebanon: "黎巴嫩",
    Jordan: "约旦",
    Syria: "叙利亚",
    Iraq: "伊拉克",
    Kuwait: "科威特",
    SaudiArabia: "沙特阿拉伯",
    Oman: "阿曼",
    Israel: "以色列",
    Bahrain: "巴林",
    Qatar: "卡塔尔",
    Bhutan: "不丹",
    Mongolia: "蒙古",
    Nepal: "尼泊尔",
    Iran: "伊朗",
    Russia: "俄罗斯",
    Greece: "希腊",
    Netherlands: "荷兰",
    Belgium: "比利时",
    France: "法国",
    Spain: "西班牙",
    Gibraltar: "直布罗陀",
    Portugal: "葡萄牙",
    Luxembourg: "卢森堡",
    Ireland: "爱尔兰",
    Iceland: "冰岛",
    Albania: "阿尔巴尼亚",
    Malta: "马耳他",
    Cyprus: "塞浦路斯",
    Finland: "芬兰",
    Bulgaria: "保加利亚",
    Hungary: "匈牙利",
    Germany: "德国",
    Yugoslavia: "南斯拉夫",
    Italy: "意大利",
    SanMarino: "圣马力诺",
    Vatican: "梵蒂冈",
    Romania: "罗马尼亚",
    Switzerland: "瑞士",
    Liechtenstein: "列支敦士登",
    Austria: "奥地利",
    UnitedKingdom: "英国",
    Denmark: "丹麦",
    Sweden: "瑞典",
    Norway: "挪威",
    Poland: "波兰",
    Egypt: "埃及",
    Morocco: "摩洛哥",
    Algeria: "阿尔及利亚",
    Tunisia: "突尼斯",
    Libya: "利比亚",
    Gambia: "冈比亚",
    Senegal: "塞内加尔",
    Mauritania: "毛里塔尼亚",
    Mali: "马里",
    Guinea: "几内亚",
    CotedIvoire: "科特迪瓦",
    BurkinaFaso: "布基拉法索",
    Niger: "尼日尔",
    Togo: "多哥",
    Benin: "贝宁",
    Mauritius: "毛里求斯",
    Liberia: "利比里亚",
    SierraLeone: "塞拉利昂",
    Ghana: "加纳",
    Nigeria: "尼日利亚",
    Chad: "乍得",
    CentralAfrica: "中非",
    Cameroon: "喀麦隆",
    CapeVerde: "佛得角",
    SaoTome: "圣多美",
    Principe: "普林西比",
    SaoTomeAndPrincipe: "圣多美和普林西比",
    EquatorialGuinea: "赤道几内亚",
    Gabon: "加蓬",
    Congo: "刚果",
    Zaire: "扎伊尔",
    Angola: "安哥拉",
    GuineaBissau: "几内亚比绍",
    Ascension: "阿森松",
    Seychelles: "塞舌尔",
    Sudan: "苏丹",
    Rwanda: "卢旺达",
    Ethiopia: "埃塞俄比亚",
    Somalia: "索马里",
    Djibouti: "吉布提",
    Kenya: "肯尼亚",
    Tanzania: "坦桑尼亚",
    Uganda: "乌干达",
    Burundi: "布隆迪",
    Mozambique: "莫桑比克",
    Zambia: "赞比亚",
    Madagascar: "马达加斯加",
    Reunion: "留尼旺岛",
    Zimbabwe: "津巴布韦",
    Namibia: "纳米比亚",
    Malawi: "马拉维",
    Lesotho: "莱索托",
    Botswana: "博茨瓦纳",
    Swaziland: "斯威士兰",
    Comoros: "科摩罗",
    SouthAfrica: "南非",
    StHelena: "圣赫勒拿",
    Aruba: "阿鲁巴岛",
    FaroeIslands: "法罗群岛",
    Midwayisland: "中途岛",
    Hawaii: "夏威夷",
    WakeIsland: "威克岛",
    Anguilla: "安圭拉岛",
    TheVirginIslands: "维尔京群岛",
    SaintLucia: "圣卢西亚",
    PuertoRico: "波多黎各",
    Jamaica: "牙买加",
    Bahamas: "巴哈马",
    Barbados: "巴巴多斯",
    Alaska: "阿拉斯加",
    Greenland: "格陵兰岛",
    Belize: "伯利兹",
    Guatemala: "危地马拉",
    Salvador: "萨尔瓦多",
    Honduras: "洪都拉斯",
    Nicaragua: "尼加拉瓜",
    CostaRica: "哥斯达黎加",
    Panama: "巴拿马",
    Haiti: "海地",
    Peru: "秘鲁",
    Mexico: "墨西哥",
    Cuba: "古巴",
    Argentina: "阿根廷",
    Brazil: "巴西",
    Chile: "智利",
    Colombia: "哥伦比亚",
    Venezuela: "委内瑞拉",
    Bolivia: "玻利维亚",
    Guyana: "圭亚那",
    Ecuador: "厄瓜多尔",
    FrenchGuiana: "法属圭亚那",
    Paraguay: "巴拉圭",
    Martinique: "马提尼克",
    Suriname: "苏里南",
    Uruguay: "乌拉圭",
    Australia: "澳大利亚",
    NewZealand: "新西兰",
    Guam: "关岛",
    CocosIsland: "科科斯岛",
    NorfolkIsland: "诺福克岛",
    Christmasisland: "圣诞岛",
    Nauru: "瑙鲁",
    Tonga: "汤加",
    SolomonIslands: "所罗门群岛",
    Vanuatu: "瓦努阿图",
    Fiji: "斐济",
    CorkIslands: "科克群岛",
    Niue: "纽埃岛",
    EasternSamoa: "东萨摩亚",
    WesternSamoa: "西萨摩亚",
    Kiribati: "基里巴斯",
    Tuvalu: "图瓦卢",
    AntiguaAndBarbuda: "安地卡及巴布达",
    BritishVirginIslands: "英属维尔京群岛",
    USVirginIslands: "美属维京群岛",
    CaymanIslands: "开曼群岛",
    Bermuda: "百慕大",
    Grenada: "格瑞那达",
    TurksAndCaicosIslands: "特克斯和凯科斯群岛",
    Montserrat: "蒙哲腊",
    AmericanSamoa: "美属萨摩亚",
    StMaarten: "荷属圣马丁",
    StLucia: "圣露西亚",
    Dominica: "多米尼克",
    StVincentAndGrenadines: "圣文森及格瑞那丁",
    DominicanRepublic: "多米尼加共和国",
    TrinidadAndTobago: "特立尼达和多巴哥",
    StKittsAndNevis: "圣克里斯多福及尼维斯",
    SouthSudan: "南苏丹",
    DiegoGarcia: "英属印度洋领地",
    Eritrea: "厄立特里亚",
    Lithuania: "立陶宛",
    Latvia: "拉脱维亚",
    Estonia: "爱沙尼亚",
    Moldova: "摩尔多瓦",
    Armenia: "亚美尼亚",
    Belarus: "白俄罗斯",
    Andorra: "安道尔",
    Monaco: "摩纳哥",
    Ukraine: "乌克兰",
    Serbia: "塞尔维亚",
    Montenegro: "黑山",
    Kosovo: "科索沃",
    Croatia: "克罗地亚",
    Slovenia: "斯洛文尼亚",
    BosniaAndHerzegovina: "波斯尼亚和黑塞哥维那",
    Macedonia: "马其顿",
    CzechRepublic: "捷克",
    Slovakia: "斯洛伐克",
    Yemen: "也门",
    Palestine: "巴勒斯坦",
    UAE: "阿联酋",
    Tajikistan: "塔吉克斯坦",
    Turkmenistan: "土库曼斯坦",
    Azerbaijan: "阿塞拜疆",
    Georgia: "格鲁吉亚",
    Kyrgyzstan: "吉尔吉斯斯坦",
    Uzbekistan: "乌兹别克斯坦",
    EastTimor: "东帝汶",
    PapuaNewGuinea: "巴布亚新几内亚",
    Palau: "帕劳",
    WallisFutuna: "瓦利斯和富图那",
    NewCaledonia: "新喀里多尼亚",
    FrenchPolynesia: "法属波利尼西亚",
    Tokelau: "托克劳",
    Micronesia: "密克罗尼西亚",
    MarshallIslands: "马绍尔群岛",
    Inmarsat: "国际海事卫星组织",
    FalklandIslands: "福克兰群岛",
    StPierreAndMiquelon: "圣皮埃尔和密克隆群岛",
    Guadeloupe: "瓜德罗普岛"
  },
  rechargeState: {
    orderState: '订单状态',
    createFail: '创建失败',
    createSuccess: '创建成功',
    submitFail: '提交失败',
    submitSuccess: '提交成功',
    notifyFail: '回调失败',
    notifySuccess: '回调成功',
    refund: '退款',
    credited: '已入帐'
  },
  refundOrder: {
    orderState: '订单状态',
    rechargeOrderNumber: '充值订单编号',
    refundAmountText: "退款金额",
    refundReasonText: "退款原因",
    netWayCodeText: "充值类型"
  },
  rechargeNotify: {
    notifyTypeText: '回执类型'
  },
  refundOrderState: {
    receiveSuccess: '接收成功',
    receiveFail: '接收失败',
    submitSuccess: '提交上游成功',
    submitFail: '提交上游失败',
    refundSuccess: '退款成功',
    refundFail: '退款失败'
  },
  currencyExchangeRateUpdateState: {
    apiUpdateText: 'API 更新',
    manualUpdateText: '手动更新'
  },
  notifyType: {
    rechargeOrderNotifyText: '支付回执',
    refundOrderNotifyText: '退款回执'
  },
  agentRemitOrder: {
    accountNo: '账号/电话',
    bank: '银行',
    alipay: '支付宝',
    weChat: '微信',
    accountName: '账号名称',
    rejectReason: '拒绝原因',
    withdrawCurrency: '提现货币类型',
    amountAfterConversion: '转换后金额',
    amountAfterConversionForTable: '对应货币提现金额',
    rate: '汇率',
    accountDetail: '账号详情'
  },
  agentAmountChangeRecord: {
    reasonForChangeInAmount: '金额改动原因',
    effectiveAmountBeforeOperation: '操作前有效金额',
    changeEffectiveAmount: '变动有效金额',
    effectiveAmountAfterOperation: '操作后有效金额',
    amountToBeCreditedBeforeOperation: '操作前待入账金额',
    changesToTheAmountToBeRecorded: '变动待入账金额',
    amountToBeCreditedAfterOperation: '操作后待入账金额'
  },
  rechargeOrderNotify: {
    getRequestSent: '已发送获取请求'
  },
  rechargeOrderRecord: {
    notifiedDownstream: '已通知下游',
    channelName: '通道名称',
    channelID: '通道ID'
  }
};
exports.default = _default;